'use client'

import React, { useEffect, useState } from 'react'
// import { useLocation, useNavigate } from 'react-router-dom'
import api from '../../lib/api.interceptor'
import { setThankYouData } from '../../store/features/projectSlice'
import { usePathname } from 'next/navigation'
import { useDispatch, useSelector } from 'react-redux'
import { useRouter } from 'next/navigation'
import { Toast } from './Toast'

function Project_details_form({ projects_full_list_detail }) {
  // const location = useLocation()
  // const navigate = useNavigate()
  const router = useRouter()
  const dispatch = useDispatch()
  const countryList = useSelector((state) => state.project.countryList)

  const activePath = usePathname()

  const [formData, setFormData] = useState({
    agree_tandc: '1',
    agree_tandc_display: 'true',
    client_name: '',
    email_address: '',
    client_contact_no_display: '',
    remarks: '',
    country: '91',
    master_user_id: '239',
    logged_in_master_user_id: '239',
    from_app: 'true',
    inquiry_from: 'web',
    user_type: 'N',
    flag: 'https://flagcdn.com/w40/in.webp'
  })

  const [errors, setErrors] = useState({})
  const [search, setSearch] = useState('')
  const [countryDropdownOpen, setCountryDropdownOpen] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const validate = () => {
    const newErrors = {}

    if (!formData.client_name.trim())
      newErrors.client_name = 'Full name is required.'
    if (activePath === '/goodwill-Tower' && !formData.remarks.trim())
      newErrors.remarks = 'This field is required.'
    if (!formData.client_contact_no_display.trim())
      newErrors.client_contact_no_display = 'Phone number is required.'

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData({ ...formData, [name]: value })
  }

  const handlePhoneKeyDown = (e) => {
    const allowedKeys = [
      'Backspace',
      'ArrowLeft',
      'ArrowRight',
      'Tab',
      'Delete'
    ]
    if (!/[0-9]/.test(e.key) && !allowedKeys.includes(e.key)) {
      e.preventDefault()
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!validate()) return
    if (isSubmitting == false) {
      setIsSubmitting(true)
      let client_contact_no =
        formData.country + ' ' + formData.client_contact_no_display
      let project_id = projects_full_list_detail.project_id
      const finalInquiryObj = { ...formData, project_id, client_contact_no }

      const response = await api.Projectinquiry(finalInquiryObj)
      if (response.success == 1) {
        // navigate(`/${projects_full_list_detail.slug}/thank_you`, {
        //   state: {
        //     page_name: projects_full_list_detail.project_title,
        //     document: projects_full_list_detail.document_other_data
        //       ? projects_full_list_detail.document_other_data
        //       : []
        //   }
        // })

        dispatch(
          setThankYouData({
            page_name: projects_full_list_detail.project_title,
            document: projects_full_list_detail.document_other_data
              ? projects_full_list_detail.document_other_data
              : []
          })
        )
        router.push(`/${projects_full_list_detail.slug}/thankyou`)

        Toast(response.message)
        setFormData({
          agree_tandc: '1',
          agree_tandc_display: 'true',
          client_name: '',
          email_address: '',
          client_contact_no_display: '',
          remarks: '',
          country: '91',
          master_user_id: '239',
          logged_in_master_user_id: '239',
          from_app: 'true',
          inquiry_from: 'web',
          user_type: 'N',
          flag: 'https://flagcdn.com/w40/in.webp'
        })
      } else {
        Toast(response.message)
      }
      setIsSubmitting(false)
    }
    // console.log(formData)
  }

  const selectCountry = (phonecode, flag) => {
    setFormData({ ...formData, country: phonecode, flag })
    setCountryDropdownOpen(false)
  }

  return (
    <>
      <section
        className="reecosys-section"
        id="reecosys-detail-section-get-touch"
      >
        <div className="inquiry_form_detail">
          <div>
            <div className="">
              <div className="section-information">
                <div className="section-title">
                  {projects_full_list_detail.project_id != 621 && (
                    <h2
                      className="text-uppercase text-center uppercase"
                      data-aos="fade-up"
                      data-aos-duration="600"
                      data-aos-delay="300"
                      ng-if=""
                    >
                      {projects_full_list_detail.project_id == 602
                        ? 'Register Your Interest'
                        : 'Book Your Site Visit'}
                    </h2>
                  )}
                  {projects_full_list_detail.project_id == 621 && (
                    <h2
                      className="text-uppercase text-center uppercase"
                      data-aos="fade-up"
                      data-aos-duration="600"
                      data-aos-delay="300"
                      ng-if=""
                    >
                      Enquire Now
                    </h2>
                  )}
                </div>
              </div>

              <div className=" project_detail_inquiry_form">
                <div
                  className="detail-page-form fade_top"
                  data-wow-duration="0.6s"
                  data-wow-delay="0.6s"
                >
                  <form onSubmit={handleSubmit}>
                    <div className="form_wrapper form_wrapper_grid">
                      <div className="contact_lable">
                        <input
                          type="text"
                          name="client_name"
                          value={formData.client_name}
                          onChange={handleInputChange}
                          placeholder=" "
                          className={`form-control ${
                            errors.client_name ? 'error' : ''
                          }`}
                          tabIndex="1"
                        />
                        <label className="md-lable" htmlFor="client_name">
                          Full Name*
                        </label>
                        {/* {errors.client_name && (
                          <div className="error">{errors.client_name}</div>
                        )} */}
                      </div>

                      <div className="contact_lable">
                        <input
                          type="email"
                          name="email_address"
                          value={formData.email_address}
                          onChange={handleInputChange}
                          placeholder=" "
                          className={`form-control ${
                            errors.email_address ? 'error' : ''
                          }`}
                          tabIndex="2"
                        />
                        <label className="md-lable" htmlFor="client_email">
                          Email Address
                        </label>
                      </div>

                      <div className="contact_lable relative">
                        <input
                          type="tel"
                          name="client_contact_no_display"
                          value={formData.client_contact_no_display}
                          onChange={handleInputChange}
                          onKeyDown={handlePhoneKeyDown}
                          placeholder=""
                          maxLength={10}
                          minLength={10}
                          className={`form-control contact-form ${
                            errors.client_contact_no_display ? 'error' : ''
                          }`}
                          tabIndex="3"
                        />
                        <label className="md-lable" htmlFor="contact_no">
                          Phone Number*
                        </label>
                        {/* {errors.client_contact_no_display && (
                          <div className="error">
                            {errors.client_contact_no_display}
                          </div>
                        )} */}

                        <div className="conatct_number_input">
                          <div
                            className="country_code_data"
                            onClick={(e) => {
                              e.stopPropagation()
                              setCountryDropdownOpen(!countryDropdownOpen)
                            }}
                          >
                            <div className="contact_country_flag">
                              <img src={formData.flag} alt="flag" />
                            </div>
                            <div>&nbsp; +{formData.country}</div>
                            <div>
                              <span className="material-symbols-outlined">
                                keyboard_arrow_down
                              </span>
                            </div>
                          </div>
                        </div>
                        {countryDropdownOpen && (
                          <div
                            className="country-overlay"
                            onClick={() => {
                              setCountryDropdownOpen(false)
                            }}
                          ></div>
                        )}
                        {countryDropdownOpen && (
                          <div
                            className="country_code_list_data active"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <div className="search_c-code">
                              <input
                                type="text"
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                placeholder="Search"
                              />
                            </div>
                            <ul>
                              {countryList
                                .filter(
                                  (country) =>
                                    country.phonecode
                                      .toLowerCase()
                                      .includes(search.toLowerCase()) ||
                                    country.nicename
                                      .toLowerCase()
                                      .includes(search.toLowerCase())
                                )
                                .map((country, i) => (
                                  <li
                                    key={i}
                                    onClick={() =>
                                      selectCountry(
                                        country.phonecode,
                                        country.flag
                                      )
                                    }
                                  >
                                    <div>
                                      <img src={country.flag} alt="flag" />
                                      <span className="display_country_code">
                                        +{country.phonecode}
                                      </span>
                                      {country.nicename}
                                    </div>
                                  </li>
                                ))}
                            </ul>
                          </div>
                        )}
                      </div>

                      {activePath === '/goodwill-Tower' ? (
                        <div className={`contact_lable commentbox`}>
                          <select
                            name="remarks"
                            value={formData.remarks}
                            onChange={handleInputChange}
                            className="form-control"
                            tabIndex="4"
                          >
                            <option
                              value=""
                              style={{ display: 'none' }}
                            ></option>
                            <option value="1 Year">1 Year</option>
                            <option value="3 Years">3 Years</option>
                            <option value="5 Years">5 Years</option>
                            <option value="More than 5 Years">
                              More than 5 Years
                            </option>
                          </select>
                          <label className="md-lable" htmlFor="remarks">
                            Tenure
                          </label>
                          {/* {errors.remarks && (
                            <div className="error">{errors.remarks}</div>
                          )} */}
                        </div>
                      ) : (
                        <div className="contact_lable commentbox">
                          <input
                            type="text"
                            name="remarks"
                            value={formData.remarks}
                            onChange={handleInputChange}
                            placeholder=""
                            className="form-control"
                            tabIndex="4"
                          />
                          <label className="md-lable" htmlFor="remark">
                            Message
                          </label>
                        </div>
                      )}

                      <div className="filled-div-button button-div wfc m0auto">
                        <button
                          className="button-style black-btn"
                          type="submit"
                          disabled={isSubmitting}
                          tabIndex="7"
                        >
                          {isSubmitting ? (
                            <div className="loading_btn"></div>
                          ) : null}
                          <p>{isSubmitting ? 'Please Wait...' : 'Submit'}</p>
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Project_details_form
